import {Podium} from "lucide-react";
import Icon from "@/components/icon";
import {BreadcrumbProvider, type Breadcrumb} from "@/features/breadcrumbs";

export const breadcrumb: Breadcrumb =
{
    dirname: __dirname,
    title: "Leaderboard",
    icon: <Icon component={Podium} />,
};

export default function Layout({children}: Readonly<{children: React.ReactNode}>)
{
    return (
        <BreadcrumbProvider {...breadcrumb}>
            {children}
        </BreadcrumbProvider>
    );
}
